export const fortunesEn_at = [
  `Love is not finding a perfect person, it is seeing an imperfect person perfectly.`,
  `An easy lie can be more useful than a complicated truth.`,
  `If all you have is a hammer, everything looks like a nail.`,
  `The only way to have a true friend is to become one.`,
  `Happiness is a result of a decision to be happy.`,
  `A bird in the hand is safer than one overhead.`,
  `There are no short cuts to any place worth going.`,
  `If you are willing to admit your faults, you have one less fault to admit.`,
  `The best way to eliminate temptation is to succumb to it!`,
  `Conceited people never get anywhere, usually because they think they're already there.`,
  `The one who says it cannot be done should never interrupt the one who is doing it.`,
  `Habits are like a rope. You add a thread every day, until it is impossible to break.`,
  `When your light is strongest, don't stand in the shadows.`,
  `Those who get the most from life are those who give the most.`,
  `You can't just land on the mountaintop. First, you have to start climbing.`,
  `Ideas are funny things. They won't work unless you do.`,
  `Happy people don't always have the best, they just make the most of what they have.`,
  `If you keep doing what you're doing, you'll keep getting what you're getting.`,
  `When you focus your efforts, you make time your ally.`,
  `There are times when the only solution is to take a break.`,
  `Everything is your teacher, if you are willing to learn.`,
  `Somedays you're the pigeon, somedays you're the statue.`,
  `Leaders see more in people than they see in themselves.`,
  `You can't milk a cow you don't have.`,
  `Whoever said "it doesn't matter if you win or lose" probably lost.`,
  `Bad habits are like a comfortable bed - easy to get into, difficult to get out of.`,
  `It's easy to be brave from a safe distance away.`,
  `Knowledge is realizing that the street is one-way, but wisdom is looking in both directions anyway.`,
  `If you see a turtle on a fence post, he had some help getting there.`,
  `Love your enemies. It'll make them absolutely crazy.`,
  `Every oak tree started out as a couple of nuts who decided to stand their ground.`,
  `Change is good... but dollar bills are better.`,
  `Eagles may soar, but weasels don't get sucked into jet engines.`,
  `The only substitute for bad manners is good reflexes.`,
  `We could all learn a lesson from the weather. It pays no attention to criticism.`,
  `The sooner you fall behind, the more time you'll have to catch up.`,
  `Don't feel bad. Half the people you know are below average.`,
  `If you think a weakness can be turned into a strength, that's another weakness.`,
  `Most of us are pretty good at keeping promises to others and pretty bad at keeping promises to ourselves.`,
  `Don't run from your fears - when they catch up with you, you'll be too tired to fight.`,
  `With every new sunrise, there is a new chance. But with every sunset, you blew it again.`,
  `Remember, pain is nature's way of reminding you who's in charge.`,
  `If you can't take the heat, don't tickle the dragon.`,
  `You never know what you can do without until you try.`,
  `Those who live by the sword... get shot by those who live by the gun.`,
  `A dog inside a kennel barks at his fleas. A dog out hunting doesn't even notice them.`,
  `Life is like a roll of toilet paper. The closer you get to the end, the faster it goes.`,
  `People seem to get nostalgic about a lot of things they weren't so crazy about the first time around.`,
  `You can't milk a cow you don't have.`,
  `When in doubt. . . mumble.`,
  `Whoever said "it doesn't matter if you win or lose" probably lost.`,
  `You may not have what it takes to finish, but you probably have what it takes to begin.`,
  `Too many people are like blisters - they don't show up until the work is done.`,
  `The easiest thing to be is yourself.`,
  `In a full heart there is room for everything. In an empty heart there is room for nothing.`,
  `It's better to have lived one day as a lion than to live a thousand years as a sheep.`,
  `Be careful when you stretch the truth - eventually it will snap back at you.`,
  `Boredom is a sign of unused potential.`,
  `Eagles may soar, but weasels don't get sucked into jet engines.`,
  `Never put off till tomorrow what you can avoid altogether.`,
  `It's a bad idea to give advice. A wise man won't need it, and a fool won't heed it.`,
  `Don't make something simple and efficient when you can make it complex and wonderful.`,
  `It is always better to fail in doing something than to excel in doing nothing.`,
  `It doesn't help to be prepared for all emergencies but totally unprepared for everyday life.`,
  `No one gets too old to learn a new way of being stupid.`,
  `Needing someone is like needing a parachute. If he isn't there the first time, chances are you won't be needing him again.`,
  `An authority is a person who can tell you more about something than you really care to know.`,
  `Time flies like an arrow. Fruit flies like a banana.`,
  `People who usually give advice are the worst people to get advice from.`,
  `If it weren't for the last minute, nothing would ever get done.`,
  `Don't go knocking on death's door. Just ring the bell and run. He hates that.`,
  `No one likes a smart aleck... especially another smart aleck.`,
  `The early bird may get the worm, but it's the second mouse that gets the cheese.`,
  `The best place to find a helping hand is at the end of your arm.`,
  `Two rules to live by: First, look out for #1. Second, don't step in #2.`,
  `Reach for the moon. If you miss, at least you will end up among the stars.`,
  `Subtlety is the art of saying what you think and getting out of the way before it is understood.`,
  `People do not resist change -- they resist being changed.`,
  `When elephants fight, only the grass gets hurt.`,
  `You are only young once, but you can be immature for your whole life.`,
  `A bend in the road is not the end of the road -- unless you fail to make the turn.`,
  `Today is a day for firm decisions! ... or is it??`,
  `People who claim they don't let little things bother them have never tried to sleep in a room with a mosquito.`,
  `The strong take from the weak, but the smart take from the strong.`,
  `There are two reasons for doing something: a really good reason and the real reason.`,
  `Just make sure the light at the end of the tunnel isn't a train approaching.`,
  `The older a man gets, the farther he had to walk to school as a boy.`,
  `The only people you should try to get even with are those who have helped you.`,
  `Anyone can admit to themselves they were wrong, but the wise man can admit it to others.`,
  `A man with a watch knows what time it is. A man with two watches is never sure.`,
  `Small minds are the first to condemn great ideas.`,
  `Resisting temptation is easier when you think you'll probably get another chance.`,
  `One does not make new friends, one just recognizes them for the first time.`,
  `Love many, trust few, and always paddle your own canoe.`,
  `Never put off till tomorrow what you can avoid altogether.`,
  `It's a bad idea to give advice. A wise man won't need it, and a fool won't heed it.`,
  `Don't make something simple and efficient when you can make it complex and wonderful.`,
  `It is always better to fail in doing something than to excel in doing nothing.`,
  `It doesn't help to be prepared for all emergencies but totally unprepared for everyday life.`,
  `No one gets too old to learn a new way of being stupid.`,
  `Live each day as if it were the last day of your life, because so far, it is.`,
  `Laughter is a mood enhancer with no side effects.`,
  `If you try too hard to be like someone else, you're wasting the time of the person you are.`,
  `It's usually easier to point a finger than to offer a helping hand.`,
  `If you don't have time to do it right the first time, you must have time to do it over.`,
  `True love is the triumph of imagination over intelligence.`,
  `Money can't buy happiness, but it's more comfortable to cry in a Porsche than on a bicycle.`,
  `If people talk negatively about you, make sure no one will believe them.`,
  `Hard work pays off in the future, but laziness pays off now.`,
  `Experience is the worst teacher. It always gives the tests first and the instruction after.`,
  `If you can't learn to do something well, learn to enjoy doing it badly.`,
  `Nostalgia is the realization that things weren't as miserable as they seemed at the time.`,
  `Life is like a raffle. You must be present to win.`,
  `Love your neighbors, but don't pull down the fence.`,
  `Never be afraid to do something new. Amateurs built the ark; professionals built the Titanic.`,
  `Some people have a large circle of friends, while other people have only friends that they like.`,
  `After all is said and done, a lot more is usually said than done.`,
  `Too many people volunteer to carry the stool when it's time to move the piano.`,
  `If you're not living on the edge, you're taking up too much space.`,
  `All generalizations are false - including this one.`,
  `Luck is just a loser's excuse for a winner's position.`,
  `If you fall flat on your face, at least you're still moving forwards.`,
  `Time is a great teacher, but eventually it kills all its pupils.`,
  `What goes around, comes around. And then it gets really dizzy and falls over.`,
  `The person who said "good things come to those who wait" is probably still waiting.`,
  `Word to the wise: Don't play leapfrog with a unicorn.`,
  `Good judgment comes from experience, and experience comes from bad judgment.`,
  `Never criticize a man until you've walked a mile in his shoes. Then say whatever you want - you're a mile away, and you have the guy's shoes!`,
  `The only person who got all his work done by Friday was Robinson Crusoe.`,
  `When arguing with a stupid person, just make sure he isn't doing the same thing.`,
  `Having the right to do something doesn't mean it is right to do it.`,
  `Many people think that they're thinking, but they're really just rearranging their prejudices.`,
  `The bad news is that time flies. The good news is this: at least you're the pilot.`,
  `You can't have everything....Where would you put it?`,
  `Choose your friends by their character and your socks by their color, not the other way around.`,
  `Money is like manure - it's not worth anything unless you spread it around.`,
  `The only weapon that becomes sharper with constant use is the tongue.`,
  `Be kind to unkind people - they're the ones that need it the most.`,
  `Happiness is often the result of being too busy to be miserable.`,
  `Growing old is mandatory. Growing up is optional.`,
  `As soon as you make something idiot-proof, along comes a bigger idiot.`,
  `We never know the worth of water until the well is dry.`,
  `The greatest pleasure in life is doing what people say you will never do.`,
  `An error is not a mistake, unless you refuse to correct it.`,
  `One reason why computers can do more work than people is that they never have to stop and answer the phone.`,
  `Even the wisest men enjoy a little nonsense, now and then.`,
  `It's always easier for one man to solve another man's problem.`,
  `For every complicated problem there is a simple, easy to understand, wrong answer.`,
  `A pessimist sees the difficulty in every opportunity; an optimist sees the opportunity in every difficulty.`,
  `Many people speak because (and only because) they don't know how to be silent.`,
  `A miser grows rich by seeming poor, an extravagant man grows poor by seeming rich.`,
  `Lightning doesn't strike every time it thunders.`,
  `A man of words but not of deeds is a garden with no flowers, only weeds.`,
  `The more difficult the obstacle, the stronger you are for tackling it.`,
  `We only ask for advice if we already know the answer but wish we didn't.`,
  `Words should be weighed, not counted.`,
  `A calm sea does not make a skilled sailor.`,
  `If you come in second, you are the first loser.`,
  `If you can't control the wind, adjust your sail.`,
  `If you step in a puddle, there's no point in blaming the puddle.`,
  `If you always do what you always did, you'll always get what you always got.`,
  `A minute of silence is more powerful than an hour of talk.`,
  `The Devil has many tools, but a lie is the handle that fits them all.`,
  `One of the greatest mistakes in life is to live as if you fear making mistakes.`,
  `Life consists not in holding good cards, but in playing those you hold well.`,
  `Nothing makes a person more productive than the last minute.`,
  `Love is not finding a perfect person, it is seeing an imperfect person perfectly.`,
  `An easy lie can be more useful than a complicated truth.`,
  `If all you have is a hammer, everything looks like a nail.`,
  `The only way to have a true friend is to become one.`,
  `Happiness is a result of a decision to be happy.`,
  `A bird in the hand is safer than one overhead.`,
  `There are no short cuts to any place worth going.`,
  `If you are willing to admit your faults, you have one less fault to admit.`,
  `The best way to eliminate temptation is to succumb to it!`,
  `Conceited people never get anywhere, usually because they think they're already there.`,
  `The one who says it cannot be done should never interrupt the one who is doing it.`,
  `Habits are like a rope. You add a thread every day, until it is impossible to break.`,
  `When your light is strongest, don't stand in the shadows.`,
  `Those who get the most from life are those who give the most.`,
  `You can't just land on the mountaintop. First, you have to start climbing.`,
  `Ideas are funny things. They won't work unless you do.`,
  `Happy people don't always have the best, they just make the most of what they have.`,
  `If you keep doing what you're doing, you'll keep getting what you're getting.`,
  `When you focus your efforts, you make time your ally.`,
  `There are times when the only solution is to take a break.`,
  `Everything is your teacher, if you are willing to learn.`,
  `Somedays you're the pigeon, somedays you're the statue.`,
  `Leaders see more in people than they see in themselves.`,
  `You can't milk a cow you don't have.`,
  `Whoever said "it doesn't matter if you win or lose" probably lost.`,
  `Bad habits are like a comfortable bed - easy to get into, difficult to get out of.`,
  `It's easy to be brave from a safe distance away.`,
  `Knowledge is realizing that the street is one-way, but wisdom is looking in both directions anyway.`,
  `If you see a turtle on a fence post, he had some help getting there.`,
  `Love your enemies. It'll make them absolutely crazy.`,
  `Every oak tree started out as a couple of nuts who decided to stand their ground.`,
  `Change is good... but dollar bills are better.`,
  `Eagles may soar, but weasels don't get sucked into jet engines.`,
  `The only substitute for bad manners is good reflexes.`,
  `We could all learn a lesson from the weather. It pays no attention to criticism.`,
  `If you eat a live toad in the morning, nothing worse will happen to you for the rest of the day.`,
  `If you have to borrow money, find a pessimist - at least they don't expect it back.`,
  `The human body was designed so that we can neither pat our own backs nor kick ourselves too easily.`,
  `Even a blind pig in a blizzard finds an acorn every once in a while.`,
  `Needing someone is like needing a parachute. If he isn't there the first time, chances are you won't be needing him again.`,
  `An authority is a person who can tell you more about something than you really care to know.`,
  `Time flies like an arrow. Fruit flies like a banana.`,
  `People who usually give advice are the worst people to get advice from.`,
  `If it weren't for the last minute, nothing would ever get done.`,
  `Don't go knocking on death's door. Just ring the bell and run. He hates that.`,
  `No one likes a smart aleck... especially another smart aleck.`,
  `The early bird may get the worm, but it's the second mouse that gets the cheese.`,
  `The best place to find a helping hand is at the end of your arm.`,
  `Two rules to live by: First, look out for #1. Second, don't step in #2.`,
  `It is better to be a nobody who accomplishes something than a somebody who accomplishes nothing.`,
  `A clean conscience makes a soft pillow.`,
  `If you lack courage to start, you're already finished.`,
  `If you love what you do, you'll never work another day in your life.`,
  `If you follow other people's advice, you'll make other people's mistakes.`,
  `If you are not the sled dog leader, the world looks pretty much the same every day.`,
  `To reach a great height, a person needs to have great depth.`,
  `Many people, when they stop to think, forget that they have to get started again.`,
  `As a rule, no one is listening... until you make a mistake.`,
  `With lies you may get ahead in the world - but you can never go back.`,
  `If you're on the mark every time, the target is either too close or too big.`,
  `Man is the only animal that blushes - or needs to.`,
  `If you look at your problem closely enough, you may see that you are part of it.`,
  `Try to forget something new every day.`,
  `Even if you try to take each day at a time, sometimes they attack you all at once.`,
  `Success comes in cans, failure comes in can'ts.`,
  `Keep your words short and sweet, just in case you need to eat them.`,
  `People and turtles are very much alike - neither one goes very far without sticking their necks out.`,
  `You are what you eat - so stay away from the jerk chicken.`,
  `Life is like a roll of toilet paper. The closer you get to the end, the faster it goes.`,
  `People seem to get nostalgic about a lot of things they weren't so crazy about the first time around.`,
  `When in doubt. . . mumble.`,
  `Whoever said "it doesn't matter if you win or lose" probably lost.`,
  `You may not have what it takes to finish, but you probably have what it takes to begin.`,
  `Too many people are like blisters - they don't show up until the work is done.`,
  `The easiest thing to be is yourself.`,
  `In a full heart there is room for everything. In an empty heart there is room for nothing.`,
  `It's better to have lived one day as a lion than to live a thousand years as a sheep.`,
  `Be careful when you stretch the truth - eventually it will snap back at you.`,
  `Boredom is a sign of unused potential.`,
  `Living in the lap of luxury is good, until luxury stands up and walks away.`,
  `The more you do, the more you'll be able to do.`,
  `It's better to have a weak enemy than a strong friend.`,
  `It's hard to leave your footprint if you spend all your time sitting down.`,
  `Some people dream big, other people perform big in real life.`,
  `When you wallow with pigs, you should expect to get dirty.`,
  `If you want to always get the last word, just apologize.`,
  `Always remember that you are unique - just like everyone else.`,
  `Success is a journey, not a destination.`,
  `It is not happiness that makes us grateful, but the gratefulness that makes us happy.`,
  `A rumor that doesn't have a leg to stand on will find another way to get around.`,
  `For your words to sink in, they must be whispered - not yelled.`,
  `People do not resist change -- they resist being changed.`,
  `When elephants fight, only the grass gets hurt.`,
  `You are only young once, but you can be immature for your whole life.`,
  `A bend in the road is not the end of the road -- unless you fail to make the turn.`,
  `Today is a day for firm decisions! ... or is it??`,
  `People who claim they don't let little things bother them have never tried to sleep in a room with a mosquito.`,
  `The strong take from the weak, but the smart take from the strong.`,
  `Just make sure the light at the end of the tunnel isn't a train approaching.`,
  `There are two reasons for doing something: a really good reason and the real reason.`,
  `The older a man gets, the farther he had to walk to school as a boy.`,
  `The only people you should try to get even with are those who have helped you.`,
  `Anyone can admit to themselves they were wrong, but the wise man can admit it to others.`,
  `A man with a watch knows what time it is. A man with two watches is never sure.`,
  `Small minds are the first to condemn great ideas.`,
  `Resisting temptation is easier when you think you'll probably get another chance.`,
  `One does not make new friends, one just recognizes them for the first time.`,
  `Love many, trust few, and always paddle your own canoe.`,
  `Never put off till tomorrow what you can avoid altogether.`,
  `It's a bad idea to give advice. A wise man won't need it, and a fool won't heed it.`,
  `Don't make something simple and efficient when you can make it complex and wonderful.`,
  `It is always better to fail in doing something than to excel in doing nothing.`,
  `It doesn't help to be prepared for all emergencies but totally unprepared for everyday life.`,
  `No one gets too old to learn a new way of being stupid.`,
  `Live each day as if it were the last day of your life, because so far, it is.`,
  `Laughter is a mood enhancer with no side effects.`,
  `If you try too hard to be like someone else, you're wasting the time of the person you are.`,
  `It's usually easier to point a finger than to offer a helping hand.`,
  `If you don't have time to do it right the first time, you must have time to do it over.`,
  `True love is the triumph of imagination over intelligence.`,
  `Money can't buy happiness, but it's more comfortable to cry in a Porsche than on a bicycle.`,
  `If people talk negatively about you, make sure no one will believe them.`,
  `Hard work pays off in the future, but laziness pays off now.`,
  `Experience is the worst teacher. It always gives the tests first and the instruction after.`,
  `If you can't learn to do something well, learn to enjoy doing it badly.`,
  `Nostalgia is the realization that things weren't as miserable as they seemed at the time.`,
  `Life is like a raffle. You must be present to win.`,
  `Love your neighbors, but don't pull down the fence.`,
  `Never be afraid to do something new. Amateurs built the ark; professionals built the Titanic.`,
  `Some people have a large circle of friends, while other people have only friends that they like.`,
  `After all is said and done, a lot more is usually said than done.`,
  `If you're not living on the edge, you're taking up too much space.`,
  `All generalizations are false - including this one.`,
  `Luck is just a loser's excuse for a winner's position.`,
  `If you fall flat on your face, at least you're still moving forwards.`,
  `Time is a great teacher, but eventually it kills all its pupils.`,
  `What goes around, comes around. And then it gets really dizzy and falls over.`,
  `The person who said "good things come to those who wait" is probably still waiting.`,
  `A waterfall is really just a bunch of drips working together.`,
  `A ship in the harbor is safe, but that is not what ships were built for.`,
  `A peacock who sits on his tail is just another turkey.`,
  `If the wolf isn't at your door, don't go find him and invite him to come in.`,
  `The best way to forget all your troubles is to wear tight shoes.`,
  `Plan to be spontaneous tomorrow.`,
  `It's better to remain silent and let them think you're a fool, than to open your mouth and prove it.`,
  `Money is not everything, but it's way ahead of whatever is in second place.`,
  `A day without sunshine is... night.`,
  `The sooner you fall behind, the more time you'll have to catch up.`,
  `Don't feel bad. Half the people you know are below average.`,
  `If you think a weakness can be turned into a strength, that's another weakness.`,
  `Most of us are pretty good at keeping promises to others and pretty bad at keeping promises to ourselves.`,
  `Don't run from your fears - when they catch up with you, you'll be too tired to fight.`,
  `With every new sunrise, there is a new chance. But with every sunset, you blew it again.`,
  `Remember, pain is nature's way of reminding you who's in charge.`,
  `If you can't take the heat, don't tickle the dragon.`,
  `You never know what you can do without until you try.`,
  `Those who live by the sword... get shot by those who live by the gun.`,
  `A dog inside a kennel barks at his fleas. A dog out hunting doesn't even notice them.`,
  `A hunch is your creativity trying to tell you something.`,
  `To err is human. It's also human to blame it on some other guy.`,
  `The trouble with doing something right the first time is that nobody appreciates how difficult it was.`,
  `Only those who do not expect anything are never disappointed.`,
  `Reach for the moon. If you miss, at least you will end up among the stars.`,
  `Subtlety is the art of saying what you think and getting out of the way before it is understood.`,
  `Many people think that they're thinking, but they're really just rearranging their prejudices.`,
  `The bad news is that time flies. The good news is this: at least you're the pilot.`,
  `You can't have everything....Where would you put it?`,
  `Choose your friends by their character and your socks by their color, not the other way around.`,
  `Money is like manure - it's not worth anything unless you spread it around.`,
  `The only weapon that becomes sharper with constant use is the tongue.`,
  `Be kind to unkind people - they're the ones that need it the most.`,
  `Happiness is often the result of being too busy to be miserable.`,
  `Growing old is mandatory. Growing up is optional.`,
  `As soon as you make something idiot-proof, along comes a bigger idiot.`,
  `We never know the worth of water until the well is dry.`,
  `The greatest pleasure in life is doing what people say you will never do.`,
  `An error is not a mistake, unless you refuse to correct it.`,
  `One reason why computers can do more work than people is that they never have to stop and answer the phone.`,
  `Even the wisest men enjoy a little nonsense, now and then.`,
  `It's always easier for one man to solve another man's problem.`,
  `For every complicated problem there is a simple, easy to understand, wrong answer.`,
  `A pessimist sees the difficulty in every opportunity; an optimist sees the opportunity in every difficulty.`,
  `Many people speak because (and only because) they don't know how to be silent.`,
  `A miser grows rich by seeming poor, an extravagant man grows poor by seeming rich.`,
  `Lightning doesn't strike every time it thunders.`,
  `A man of words but not of deeds is a garden with no flowers, only weeds.`,
  `The more difficult the obstacle, the stronger you are for tackling it.`,
  `We only ask for advice if we already know the answer but wish we didn't.`,
  `Words should be weighed, not counted.`,
  `A calm sea does not make a skilled sailor.`,
  `If you come in second, you are the first loser.`,
  `If you can't control the wind, adjust your sail.`,
  `If you step in a puddle, there's no point in blaming the puddle.`,
  `If you always do what you always did, you'll always get what you always got.`,
  `A minute of silence is more powerful than an hour of talk.`,
  `The Devil has many tools, but a lie is the handle that fits them all.`,
  `One of the greatest mistakes in life is to live as if you fear making mistakes.`,
  `Life consists not in holding good cards, but in playing those you hold well.`,
  `Nothing makes a person more productive than the last minute.`,
  `A man of words but not of deeds is a garden without flowers, only weeds.`,
  `A man of words but not deeds is a garden without flowers, only weeds.`,
  `Love is not finding a perfect person, it is seeing an imperfect person perfectly.`,
  `An easy lie can be more useful than a complicated truth.`,
  `If all you have is a hammer, everything looks like a nail.`,
  `The only way to have a true friend is to become one.`,
  `Happiness is a result of a decision to be happy.`,
  `A bird in the hand is safer than one overhead.`,
  `There are no short cuts to any place worth going.`,
  `If you are willing to admit your faults, you have one less fault to admit.`,
  `The best way to eliminate temptation is to succumb to it!`,
  `Conceited people never get anywhere, usually because they think they're already there.`,
  `The one who says it cannot be done should never interrupt the one who is doing it.`,
  `Habits are like a rope. You add a thread every day, until it is impossible to break.`,
  `When your light is strongest, don't stand in the shadows.`,
  `Those who get the most from life are those who give the most.`,
  `Everything is your teacher, if you are willing to learn.`,
  `Somedays you're the pigeon, somedays you're the statue.`,
  `Leaders see more in people than they see in themselves.`,
  `You can't milk a cow you don't have.`,
  `Whoever said "it doesn't matter if you win or lose" probably lost.`,
  `Bad habits are like a comfortable bed - easy to get into, difficult to get out of.`,
  `It's easy to be brave from a safe distance away.`,
  `Money can't buy happiness, but it's more comfortable to cry in a Porsche than on a bicycle.`,
  `If people talk negatively about you, make sure no one will believe them.`,
  `Hard work pays off in the future, but laziness pays off now.`,
  `Experience is the worst teacher. It always gives the tests first and the instruction after.`,
  `If you can't learn to do something well, learn to enjoy doing it badly.`,
  `Nostalgia is the realization that things weren't as miserable as they seemed at the time.`,
  `Life is like a raffle. You must be present to win.`,
  `Love your neighbors, but don't pull down the fence.`,
  `Love your enemies. It'll make them absolutely crazy.`,
  `Every oak tree started out as a couple of nuts who decided to stand their ground.`,
  `Change is good... but dollar bills are better.`,
  `Eagles may soar, but weasels don't get sucked into jet engines.`,
  `The only substitute for bad manners is good reflexes.`,
  `We could all learn a lesson from the weather. It pays no attention to criticism.`,
  `The sooner you fall behind, the more time you'll have to catch up.`,
  `If you can't take the heat, don't tickle the dragon.`,
  `Don't feel bad. Half the people you know are below average.`,
  `Don't run from your fears - when they catch up with you, you'll be too tired to fight.`,
  `Most of us are pretty good at keeping promises to others and pretty bad at keeping promises to ourselves.`,
  `Remember, pain is nature's way of reminding you who's in charge.`,
  `You never know what you can do without until you try.`,
  `If you think a weakness can be turned into a strength, that's another weakness.`,
  `With every new sunrise, there is a new chance. But with every sunset, you blew it again.`,
  `Those who live by the sword... get shot by those who live by the gun.`,
  `A dog inside a kennel barks at his fleas. A dog out hunting doesn't even notice them.`,
  `Life is like a roll of toilet paper. The closer you get to the end, the faster it goes.`,
  `People seem to get nostalgic about a lot of things they weren't so crazy about the first time around.`,
  `You can't milk a cow you don't have.`,
  `When in doubt. . . mumble.`,
  `Whoever said "it doesn't matter if you win or lose" probably lost.`,
  `You may not have what it takes to finish, but you probably have what it takes to begin.`,
  `Too many people are like blisters - they don't show up until the work is done.`,
  `The easiest thing to be is yourself.`,
  `In a full heart there is room for everything. In an empty heart there is room for nothing.`,
  `It's better to have lived one day as a lion than to live a thousand years as a sheep.`,
  `Be careful when you stretch the truth - eventually it will snap back at you.`,
  `Boredom is a sign of unused potential.`,
  `Eagles may soar, but weasels don't get sucked into jet engines.`,
  `Never put off till tomorrow what you can avoid altogether.`,
  `A ticket will get you on the train, but garlic will get you a seat.`,
  `Ask for forgiveness today! Tomorrow you might not feel so guilty.`,
  `Don't have a battle of wits with an unarmed opponent.`,
  `If at first you don't succeed, hide all evidence that you ever tried.`,
  `Don't use a big word when a diminutive one will suffice perfectly appropriately.`,
  `Experience is something you don't get until just after you need it.`,
  `Live each day as if it were your last. One of these days, you'll be right.`,
  `Never criticize a man until you've walked a mile in his shoes. Then say whatever you want - you're a mile away, and you have the guy's shoes!`,
  `It's a small world... but you still wouldn't want to paint it.`,
  `A clean conscience makes a soft pillow.`,
  `People would worry less about what others think of them if they only realized how seldom they do.`,
  `Nothing improves your memory as much as trying to forget.`,
  `The difference between genius and stupidity is that genius has limits.`,
  `Success is like a wheelbarrow. Nothing happens unless you start pushing.`,
  `The early bird may get the worm, but it's the second mouse that gets the cheese.`,
  `The human body was designed so that we can neither pat our own backs nor kick ourselves too easily.`,
  `The person who says it can't be done shouldn't interrupt the person who's doing it.`,
  `The largest room in the world is the room for improvement.`,
  `The tallest blade of grass is the first to be cut by the mower.`,
  `A little nonsense now and then is cherished by the wisest men.`,
  `When you're in deep water, it's a good idea to keep your mouth shut.`,
  `Be consistent, but not all the time.`,
  `The quickest way to double your money is to fold it in half and put it back in your pocket.`,
  `The difference between genius and stupidity is that genius has limits.`,
  `The best way to find something you've lost is to replace it.`,
  `Responsible people face the music, even if they hate the tune.`,
  `A ship in a calm sea doesn't travel far.`,
  `Ask a stupid question, look silly for five minutes. Ask no questions, look silly forever.`,
  `The only culture some people have is growing on the leftovers in their refrigerators.`,
  `You are only young once, but with practice, you can be immature for your whole life.`,
  `Don't think there are no crocodiles just because the water is calm.`,
  `Even a blind pig in a blizzard finds an acorn every once in a while.`,
  `Too many people volunteer to carry the stool when it's time to move the piano.`,
  `Beware: Sometimes the light at the end of the tunnel says "NO EXIT."`,
  `A closed mouth gathers no foot.`,
  `Borrow money from a pessimist: they won't expect you to pay them back.`,
  `Confidence is the feeling you have before you understand the situation.`,
  `Two wrongs don't make a right... but three lefts do.`,
  `Contentment isn't getting everything you want - it's realizing that you already have it.`,
  `Two things that are difficult to handle gracefully: failure and success.`,
  `The true greatness of people is revealed by how they treat those who cannot do them a favor.`,
  `A conceited person never gets anywhere - he's always sure he's already there.`,
  `A good relationship is like a casserole - only those who make it happen know exactly what's in it.`,
  `A clear conscience is the sign of a poor memory.`,
  `Astronomers say the universe is finite... which is a comforting thought for those people who can't find their keys.`,
  `A clean tie is sure to attract the soup of the day.`,
  `Two rules to live by: First, look out for #1. Second, don't step in #2.`,
  `An authority is a person who can tell you more about something than you really care to know.`,
  `If you are upset over what you don't have, you will waste what you do have.`,
  `Conscious is when you're aware of something. Conscience is when you wish you weren't.`,
  `Count your age with friends, not with years.`,
  `When elephants fight, only the grass gets hurt.`,
  `True love is the triumph of imagination over intelligence.`,
  `A rumor that doesn't have a leg to stand on will find another way to get around.`,
  `A person is just about as big as the things that make them angry.`,
  `Worry gives a small thing a big shadow.`,
  `You are what you eat - so stay away from the jerk chicken.`,
  `Always remember that you are unique -- just like everyone else.`,
  `Worry is like a rocking chair. You end up expending a lot of effort without getting anywhere.`,
  `A computer may be able to beat you at chess... but probably not at kickboxing.`,
  `A meeting is an event where minutes are taken and hours are wasted.`,
  `You'll never discover new oceans unless you have are willing to lose sight of the shore.`,
  `A bird in the hand is a lot messier than two in the bush.`,
  `There is a great difference between knowledge and intelligence.`,
  `Nothing makes a fish bigger than almost being caught.`,
  `As a rule, no one is paying any attention to you... until you make a mistake.`,
  `Good judgment comes from experience, and experience comes from bad judgment.`,
  `Don't go knocking on death's door.... Just ring the bell and run. He hates that!`,
  `If it weren't for the last minute, nothing would ever get done.`,
  `A poor excuse is better than none at all.`,
  `A good lie finds more believers than a bad truth.`,
  `It's better to ask twice than to lose your way once.`,
  `The most effective way to appear wise is to stay silent.`,
  `If you come to the end of your rope -- tie a knot in it and hang on.`,
  `A guilty conscience needs no accuser.`,
  `Make your home clean enough to be healthy, and messy enough to be happy.`,
  `Try to forget something new every day.`,
  `In meetings, think carefully about how often you jump in. Make sure to reserve your airtime for the points you think are the MOST important.`,
  `The stable wears out a horse more than the road.`,
  `Some people have tact; others tell the truth.`,
  `Envy shoots at others, but hits itself.`,
  `Bad breath is better than no breath at all.`,
  `When arguing with stupid people, just make sure they aren't doing the same thing.`,
  `If there were no fools in the world, all people would agree on everything.`,
  `You can't just land on the mountaintop. First, you have to start climbing.`,
  `No one likes a smart aleck... especially another smart aleck.`,
  `With lies you may get ahead in the world - but you can never go back.`,
  `Time flies like an arrow. Fruit flies like a banana.`,
  `Opportunity always knocks at the least opportune moment.`,
  `Patience is the art of concealing your impatience.`,
  `People who say "I don't play games" are playing one.`,
  `The best place to find a helping hand is at the end of your arm.`,
  `The fastest way to find something you've lost is to replace it.`,
  `A bend in the road is not the end of the road -- unless you fail to make the turn.`,
  `The person who said "good things come to those who wait" is probably still waiting.`,
  `The thinnest reed will bend in the wind, while the tallest oak... makes a lot of great furniture.`,
  `The secret to success is knowing who to blame for your failures.`,
  `oday is a good day to make a firm decision. Or is it?`,
  `Trust is attained only after many actions, but can be lost with only one.`,
  `If you step in a puddle, there's no point in blaming the puddle.`,
  `If you always do what you always did, you'll always get what you always got.`,
  `A minute of silence is more powerful than an hour of talk.`,
  `The devil has many tools, but a lie is the handle that fits them all.`,
  `One of the greatest mistakes in life is to live as if you fear making mistakes.`,
  `Life consists not in holding good cards, but in playing those you hold well.`,
  `Nothing makes a person more productive than the last minute.`,
  `Love is not finding a perfect person, it is seeing an imperfect person perfectly.`,
  `An easy lie can be more useful than a complicated truth.`,
  `If all you have is a hammer, everything looks like a nail.`,
  `The only way to have a true friend is to become one.`,
  `Happiness is a result of a decision to be happy.`,
  `If you look at your problem closely enough, you may see that you are part of it.`,
  `A man with a watch knows what time it is. A man with two watches is never sure.`,
  `An open mind and a closed mouth make a happy combination.`,
  `Beauty is in the eye of the beholder - or else that's just that morning gunk in there or something.`,
  `Don't make everything simple and efficient when you might make it complex and wonderful.`,
  `Don't sweat the petty things. Don't pet the sweaty things, either.`,
  `Efficiency is nothing more than intelligent laziness.`,
  `A crumb from a winner's table tastes better than a feast from a loser's table.`,
  `What if there were no hypothetical situations?`,
  `When your big dreams turn to dust, it's time to find the vacuum.`,
  `Why is it that when the piano needs to be moved, everyone rushes to grab the stool?`,
  `You are not who you think you are, you are not who they think you are, but you could be who you think they think you are.`,
  `The goal of science is to build better mousetraps. The goal of nature is to build better mice.`,
  `The older a man gets, the farther he had to walk to school as a boy.`,
  `The secret to success is figuring out who to blame for your failures.`,
  `The worst cookie is better than the best brussels sprout.`,
  `There are two kinds of people in the world: givers and takers. The takers eat better, but the givers sleep better.`,
  `Time is a great teacher, but eventually it kills all its pupils.`,
  `Waste not fresh tears over old griefs.`,
  `What if there were no hypothetical situations?`,
  `When you wallow with pigs, you should expect to get dirty.`,
  `When your work speaks for itself, try not to interrupt it.`,
  `A good scare is more helpful than good advice.`,
  `Word to the wise: Don't play leapfrog with a unicorn.`,
  `People who keep their opinions to themselves will seldom be wrong.`,
  `You can't discover new oceans unless you're willing to lose sight of the dock.`,
  `Even if you try to take each day at a time, sometimes they attack you all at once.`,
  `You need to know enough to know that you don't know enough.`,
  `The only substitute for bad manners is good reflexes.`,
  `We could all learn a lesson from the weather. It pays no attention to criticism.`,
  `If you eat a live toad in the morning, nothing worse will happen to you for the rest of the day.`,
  `If you have to borrow money, find a pessimist - at least they don't expect it back.`,
  `The human body was designed so that we can neither pat our own backs nor kick ourselves too easily.`,
  `Even a blind pig in a blizzard finds an acorn every once in a while.`,
  `Needing someone is like needing a parachute. If he isn't there the first time, chances are you won't be needing him again.`,
  `An authority is a person who can tell you more about something than you really care to know.`,
  `Time flies like an arrow. Fruit flies like a banana.`,
  `People who usually give advice are the worst people to get advice from.`,
  `The best-laid plans of mice and men... usually involve cheese.`,
  `Don't go knocking on death's door. Just ring the bell and run. He hates that.`,
  `If you can't laugh at yourself, you may be missing the joke of the century.`,
  `People and turtles are very much alike - neither one goes very far without sticking their necks out.`,
  `If you don't have time to do it right the first time, you must have time to do it over.`,
  `Even if you try to take each day at a time, sometimes they attack you all at once.`,
  `It is better to be a nobody who accomplishes something than a somebody who accomplishes nothing.`,
  `All generalizations are false - including this one.`,
  `If you lack courage to start, you're already finished.`,
  `If you love what you do, you'll never work another day in your life.`,
  `If you follow other people's advice, you'll make other people's mistakes.`,
  `If you are not the sled dog leader, the world looks pretty much the same every day.`,
  `To reach a great height, a person needs to have great depth.`,
  `Many people, when they stop to think, forget that they have to get started again.`,
  `A man of words but not of deeds is a garden with no flowers, only weeds.`,
  `As soon as you make something idiot-proof, along comes a bigger idiot.`,
  `If you're on the mark every time, the target is either too close or too big.`,
  `Man is the only animal that blushes - or needs to.`,
  `Happiness is often the result of being too busy to be miserable.`,
  `If you fall flat on your face, at least you're still moving forwards.`,
  `Having the right to do something doesn't mean it is right to do it.`,
  `Ideas are funny things. They won't work unless you do.`,
  `Happy people don't always have the best, they just make the most of what they have.`,
  `If you keep doing what you're doing, you'll keep getting what you're getting.`,
  `When you focus your efforts, you make time your ally.`,
  `There are times when the only solution is to take a break.`,
  `Knowledge is realizing that the street is one-way, but wisdom is looking in both directions anyway.`,
  `If you see a turtle on a fence post, he had some help getting there.`,
  `It's hard to leave your footprint if you spend all your time sitting down.`,
  `Some people dream big, other people perform big in real life.`,
  `If you want to always get the last word, just apologize.`,
  `It is not happiness that makes us grateful, but the gratefulness that makes us happy.`,
  `For your words to sink in, they must be whispered - not yelled.`,
  `People do not resist change -- they resist being changed.`,
  `The more difficult the obstacle, the stronger you are for tackling it.`,
  `Today is a day for firm decisions! ... or is it??`,
  `People who claim they don't let little things bother them have never tried to sleep in a room with a mosquito.`,
  `The more you do, the more you'll be able to do.`,
  `It's better to have a weak enemy than a strong friend.`,
  `A pessimist sees the difficulty in every opportunity; an optimist sees the opportunity in every difficulty.`,
  `An error is not a mistake, unless you refuse to correct it.`,
  `Money is not everything, but it's probably way ahead of whatever is in second place.`,
  `Resisting temptation is easier when you think you'll probably get another chance.`,
  `You can't control the wind, but you can adjust your sail.`,
  `Success is a journey, not a destination.`,
  `It is always better to fail in doing something than to excel in doing nothing.`,
  `If you are willing to admit your faults, you have one less fault to admit.`,
  `Faith is the bird that feels the light and sings while the dawn is still dark.`,
  `Generosity will repay itself sooner than you imagine.`,
  `Fools use tomorrow. Wise use today.`
]
